export default __webpack_public_path__ + "media/images/mailer/icon_person_add-e630b4c2fc4e8ee6a6e53d48bf4cbdec.png";